<mat-drawer-container class="drawer-container" autosize>
  <mat-drawer #drawer mode="over" position="end" [opened]="false">
    <div class="drawer-content">
      <span (click)="closeDrawer()" class="draw_close">
        <img src="{{this.apiservices.frontendAssetsUrl}}draw_close.svg" alt="Close Drawer">
      </span>
    </div>

    <div class="form_heading">
      <div class="heading-submenu">General Search</div>
    </div>

    <form class="example-form" [formGroup]="formGroup" (ngSubmit)="onSubmit()">
      <!-- Gender and Seeking Fields -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <label for="gender">I am:</label>
          <mat-select formControlName="gender">
            <mat-option value="">Not Selected</mat-option>
            <mat-option *ngFor="let gender of dropDownData?.genders || [] " [value]="gender._id">
              {{ gender.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('gender')?.hasError('required')">
            Please select your gender.
          </mat-error>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <label for="seeking">Seeking a:</label>
          <mat-select formControlName="seeking">
            <mat-option value="">Not Selected</mat-option>
            <mat-option *ngFor="let gender of dropDownData?.genders || []" [value]="gender._id">
              {{ gender.name }}
            </mat-option>
          </mat-select>
          <mat-error *ngIf="formGroup.get('seeking')?.hasError('required')">
            Please select what you're seeking.
          </mat-error>
        </mat-form-field>
      </div>

      <!-- Date of Birth Fields -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="full-width">
          <label for="age_from">Age</label>
          <mat-select formControlName="age_from" (selectionChange)="onFromAgeChange($event.value)">
            <mat-option value="">From</mat-option>
            <mat-option *ngFor="let age of ageOptions" [value]="age">{{ age }}</mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="full-width">
          <mat-select formControlName="age_to">
            <mat-option value="">To</mat-option>
            <mat-option *ngFor="let age of toageOptions" [value]="age">{{ age }}</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <!-- Location Fields -->
      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <label for="country">Country</label>
          <mat-select formControlName="country" (selectionChange)="onCountryChange($event)">
            <mat-option value="">Not Selected</mat-option>
            <mat-option *ngFor="let country of countrys" [value]="country._id">
              {{ country.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <label for="state">State</label>
          <mat-select formControlName="state" (selectionChange)="onStateChange($event)">
            <mat-option value="">Select</mat-option>
            <mat-option *ngFor="let state of state" [value]="state._id">
              {{ state.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <div class="form-row">
        <mat-form-field appearance="outline" class="form-field">
          <label for="city">City</label>
          <mat-select formControlName="city">
            <mat-option value="">Select</mat-option>
            <mat-option *ngFor="let city of city" [value]="city._id">
              {{ city.name }}
            </mat-option>
          </mat-select>
        </mat-form-field>

        <mat-form-field appearance="outline" class="form-field">
          <label for="online">Online Only</label>
          <mat-select formControlName="online">
            <mat-option value="">Not Stated</mat-option>
            <mat-option value="0">No</mat-option>
            <mat-option value="1">Yes</mat-option>

          </mat-select>
        </mat-form-field>
      </div>


      <div class="advance_search">
        <mat-accordion>
          <mat-expansion-panel (opened)="panelOpenState.set(true)" (closed)="panelOpenState.set(false)">
            <mat-expansion-panel-header>
              <mat-panel-title> Advance Search </mat-panel-title>
            </mat-expansion-panel-header>

            <!-- Seeking Section -->
            <div class="section">
              <h3>Seeking</h3>
              <div class="checkbox-group">
                <mat-checkbox *ngFor="let seeking of dropDownData?.seekingFor" id="{{seeking._id}}"
                  name="{{seeking.name}}" [checked]="seekingArray.includes(seeking._id)"
                  (change)="onCheckboxChange('seeking', seeking._id, $event.checked)">{{seeking.name}}</mat-checkbox>
              </div>
            </div>

            <!-- Pets Section -->
            <div class="section">
              <h3>Pets</h3>
              <div class="checkbox-group">
                <mat-checkbox *ngFor="let pets of dropDownData?.pets" 
                  [checked]="petsArray.includes(pets._id)"
                  (change)="onCheckboxChange('pets', pets._id, $event.checked)">{{pets.name}}</mat-checkbox>
              </div>
            </div>

          </mat-expansion-panel>
        </mat-accordion>
      </div>
      <button mat-raised-button color="primary" type="submit"> {{is_load_draw?"Please Wait...": "Submit" }}<mat-spinner *ngIf="is_load_draw" class="custom-spinner"></mat-spinner></button>
    </form>
  </mat-drawer>

  <mat-drawer-content>
    <!-- This space is intentionally left empty as the drawer is controlled externally -->
  </mat-drawer-content>
</mat-drawer-container>